/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import MaterialTable from "material-table";
import CircularLoading from "../../components/CircularLoading";
import { useSelector, useDispatch } from "react-redux";
import { FirebaseContext } from "common";
const BrokerListings = () => {
  const { api } = useContext(FirebaseContext);
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const [data, setData] = useState([]);
  const listingReducer = useSelector((state) => state.ListingData.listing);
  const [listings, setlistings] = useState([]);

  const columns = [
    { title: "Size Min", field: "sizeMin" },
    { title: "Size Max", field: "sizeMax" },
    { title: "Type", field: "type" },
    { title: "Area", field: "locationSize" },
  ];
  useEffect(() => {
    if (listingReducer) {
      console.log("Enquiries", listingReducer);

      setlistings(listingReducer);
    }
  }, [listingReducer]);

  return data.loading ? (
    <CircularLoading />
  ) : (
    <MaterialTable
      title="Stock"
      columns={columns}
      data={listings}
      options={{
        exportButton: true,
        sorting: true,
        actionsColumnIndex: -1,
        filtering: true,
      }}
      editable={{
        onRowAdd: (newData) =>
          new Promise((resolve, reject) => {
            setTimeout(() => {}, 600);
          }),

        onRowUpdate: (newData, oldData) =>
          new Promise((resolve) => {
            setTimeout(() => {
              resolve();
              // dispatch(editUser(oldData.id, newData));
            }, 600);
          }),
        onRowDelete: (oldData) =>
          features.AllowCriticalEditsAdmin
            ? new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  // dispatch(deleteUser(oldData.id));
                }, 600);
              })
            : new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  // alert(language.demo_mode);
                }, 600);
              }),
      }}
    />
  );
};
export default BrokerListings;
